module.exports = __webpack_public_path__ + "static/media/vehicle_market.a660ba5d.png";